import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { message } from 'antd';
import { clearAuth, getToken } from '@/services/nora/auth';

type ServerResponse = {
  success?: boolean;
  message?: string;
  errorMessage?: string;
  data?: unknown;
};

export const errorConfig: RequestConfig = {
  errorConfig: {
    errorThrower: (res) => {
      const data = res as ServerResponse;
      if (data?.success === false) {
        const error: any = new Error(data.message || data.errorMessage || '请求失败');
        error.name = 'BizError';
        error.info = data;
        throw error;
      }
    },
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (error.name === 'BizError') {
        message.error(error.info?.message || error.message || '请求失败');
        return;
      }

      if (error.response?.status === 401) {
        clearAuth();
        message.warning('登录已过期，请重新登录');
        history.replace('/user/login');
        return;
      }

      if (error.response?.status === 403) {
        message.error(error.response?.data?.message || '权限不足');
        return;
      }

      message.error(error.response?.data?.message || error.message || '请求失败，请稍后重试');
    },
  },
  requestInterceptors: [
    (config: any) => {
      const token = getToken();
      if (token) {
        config.headers = {
          ...(config.headers || {}),
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
  ],
  responseInterceptors: [
    (response: any) => {
      if (response?.status === 401) {
        clearAuth();
        history.replace('/user/login');
      }
      return response;
    },
  ],
};
